import { DrawCabinetFrontElement } from './DrawCabinetFrontElement';

export class DrawFrontPanel extends DrawCabinetFrontElement {
}
